import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { link } from 'node:fs';

@Component({
  selector: 'app-buy-book',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './buy-book.component.html',
  styleUrl: './buy-book.component.css'
})
export class BuyBookComponent {

    ngOnInit(): void {
    // window.location.href = "https://www.silverzone.org/books";
  }

//   book = [
//     {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Comprehensive Book',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     },
//      {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Excellence Guide',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     },
//       {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Comprehensive Book',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     },
//        {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Comprehensive Book',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     },
//         {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Comprehensive Book',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     }, {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Comprehensive Book',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     }, {
//       img:'https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png',
//       bookName: 'Comprehensive Book',
//       discription:'The main benefit of The Book is that it helps students prepare for Olympiad exams by offering them challenging and stimulating questions.These questions require students to use abstract thinking and reasoning skills, essential for solving complex problems... ',
//       link:'https://www.silverzone.org/books?clid=1&cid=1&pt=1'


//     }
        
  //   ]
  
  // book = [
  //   {
  //  bookName: 'Comprehensive Book',

  //   }
 


  // ]


}
